import {
    BrandingFooter,
    BrandingHeader
} from '@models/branding';
import {UploadDocumentsConfig} from '@services/ConfigurationValuesService';

export enum Constants {
    applicationName = 'APPLICATION_NAME',
    piwikUrl = 'PIWIK_URL',
    piwikTrackingId = 'PIWIK_TRACKING_ID',
    version = 'version',
    apiUrl = 'apiUrl',
    preferredLocale = 'preferredLocale',
    uscisWebsiteUrl = 'uscisWebsiteUrl',
    uscisSection3FormI9Url = 'uscisSection3FormI9Url',
    uscisSection2FormI9Url = 'uscisSection2FormI9Url',
    uscisSection2FormI9UrlText = 'uscisSection2FormI9UrlText',
    showExtraUploadInstructions = 'showExtraUploadInstructions',
    personPidKey = 'PERSON_PID_KEY',
    i9ListADocuments = 'i9ListADocuments',
    i9ListBDocuments = 'i9ListBDocuments',
    i9ListCDocuments = 'i9ListCDocuments',
    personPidIvLength = 'personPidIvLength',
    prepopulateI9DocumentDetails = 'prepopulateI9DocumentDetails',
    brandingFooter = 'brandingFooter',
    supportUrl = 'supportUrl',
    faqUrl = 'faqUrl',
    privacyPolicyUrl = 'privacyPolicyUrl',
    partnerId = 'partnerId',
    brandingHeader = 'brandingHeader',
    hideDocumentsPhysicallyExamined = 'hideDocumentsPhysicallyExamined',
    enabledUploadDocuments = 'enabledUploadDocuments',
    uploadDocuments = 'uploadDocuments',
    displayInvitationLink = 'displayInvitationLink',
    invitationURL = 'invitationURL',
    defaultTodaysDateToToday = 'defaultTodaysDateToToday',
    showSection1 = 'showSection1',
    enableLanguageES = 'enableLanguageES',
    expirationDateForAllListA = 'expirationDateForAllListA',
    bannerHeaderUrl = 'bannerHeaderUrl',
    contactLinkFooterUrl = 'contactLinkFooterUrl',
    sentryDsnUrl = 'sentryDsnUrl',
    tracesSampleRate = 'tracesSampleRate',
    sentryEnvironment = 'sentryEnvironment'
}

export interface ConstantsMap {
    APPLICATION_NAME: string;
    PIWIK_URL: string;
    PIWIK_TRACKING_ID: number;
    version: string;
    apiUrl: string;
    preferredLocale: string;
    uscisWebsiteUrl: string;
    uscisSection3FormI9Url: string;
    uscisSection2FormI9Url: string;
    uscisSection2FormI9UrlText: string;
    showExtraUploadInstructions: boolean,
    PERSON_PID_KEY: string;
    personPidIvLength: number;
    i9ListADocuments: string[];
    i9ListBDocuments: string[];
    i9ListCDocuments: string[];
    prepopulateI9DocumentDetails: boolean;
    brandingFooter: BrandingFooter;
    faqUrl: string;
    contactUrl: string;
    supportUrl: string;
    privacyPolicyUrl: string;
    partnerId: string;
    brandingHeader: BrandingHeader;
    hideDocumentsPhysicallyExamined: boolean;
    enabledUploadDocuments: boolean;
    uploadDocuments: UploadDocumentsConfig;
    displayInvitationLink: boolean;
    invitationURL: string;
    defaultTodaysDateToToday: boolean;
    showSection1: boolean;
    enableLanguageES: boolean;
    sentryDsnUrl: string;
    tracesSampleRate: number;
    sentryEnvironment: string;
}

export const emptyConstants: ConstantsMap = {
    APPLICATION_NAME: '',
    PERSON_PID_KEY: '',
    personPidIvLength: 16,
    PIWIK_TRACKING_ID: 0,
    PIWIK_URL: '',
    apiUrl: '',
    i9ListADocuments: [],
    i9ListBDocuments: [],
    i9ListCDocuments: [],
    preferredLocale: '',
    uscisSection2FormI9Url: '',
    uscisSection2FormI9UrlText: '',
    showExtraUploadInstructions: false,
    uscisSection3FormI9Url: '',
    uscisWebsiteUrl: '',
    version: '',
    prepopulateI9DocumentDetails: true,
    brandingFooter: BrandingFooter.FooterLinks,
    brandingHeader: BrandingHeader.TopBar,
    faqUrl: '',
    contactUrl: '',
    supportUrl: '',
    privacyPolicyUrl: '',
    partnerId: 'partner',
    hideDocumentsPhysicallyExamined: false,
    enabledUploadDocuments: false,
    uploadDocuments: {
        uploadFileSizeLimitMB: 0,
        acceptedFileTypes: '',
        acceptableDocumentsUrl: '',
        eVerifyDocsOnly: false,
        eVerifyAllowedDocs: []
    },
    displayInvitationLink: false,
    invitationURL: '',
    defaultTodaysDateToToday: false,
    showSection1: false,
    enableLanguageES: false,
    sentryDsnUrl: '',
    tracesSampleRate: 1.0,
    sentryEnvironment: 'development'
};



// WEBPACK FOOTER //
// ./src/models/Constants.ts